<template>		
	<input v-if="isDisabled" type="text" class="form-control" v-model="interVal" ref="pickrInput" readonly>
	
	<span v-else class="curr_datepicker">
    <span class="control has-addons flatpickr" ref="pickrInput" v-if="isWrap">
      <input class="input"
             :name="name"
             :placeholder="placeholder"
             type="text"
             v-model="interVal" data-input>
      <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
      <a class="button" data-clear><i class="fa fa-close"></i></a>
    </span>
    <p class="control has-icon has-icon-right" v-else>
      <input class="input" :name="name" :placeholder="placeholder" type="text" v-model="interVal" ref="pickrInput">
      <i class="fa fa-calendar"></i>
      <i class="fa fa-times" @click.prevent="handleClear"></i>
    </p>
  </span>	
  
</template>
<script>
import Flatpickr from 'flatpickr'
import { zh } from 'flatpickr/dist/l10n/zh';// eslint-disable-line

export default {
  name: 'Datepicker',
  props: {
    options: {
      type: Object,
      default () {
      	return {
      		locale: zh,
    		animate: false,
      		wrap: true
			 //   enableTime:true
			 }
      }
    },
    name: String,
    placeholder: String,
    val: String,
    value: {},
    isDisabled: false,
    enableTime: false,
    enableSeconds: false,
    time_24hr: false
  },

  data () {
    return {
      interVal: this.value,
      flatPickr: null
    }
  },

  computed: {
    isWrap () {
     /* if (this.options) {
        return !!this.options.wrap;
      } */
      return true
    }
  },

  methods: {
    changeVal () {
      this.$emit('input', this.interVal)
    },
    handleClear () {
      this.flatPickr && this.flatPickr.clear()
    },
    handleClose () {
    	this.flatPickr && this.flatPickr.close()
    }
  },

  watch: {
    interVal (val) {
      this.interVal = val
      this.$emit('input', this.interVal)
    },
    value (val) {
    	this.interVal = val
    }
  },
  mounted () {
    const pickrEl = this.$refs.pickrInput
    this.options.wrap = true
    this.options.animate = false
    this.options.enableTime = this.enableTime
    this.options.enableSeconds = this.enableSeconds
    this.options.time_24hr = this.time_24hr
    this.options.onClose = (selectedDates, dateStr, instance) => {
		// Force the input to lose focus when closed
      instance.input.blur()
    }
    this.flatPickr = new Flatpickr(pickrEl, this.options)
    let obj = $('#content-main .childComp .tabBox')
    const that = this
    obj.on('scroll', function () {
    	that.handleClose()
    })
  },
  beforeDestroy () {
    if (this.flatPickr) {
      this.flatPickr.destroy()
      this.flatPickr = null
    }
  }
}
</script>
<style scoped lang="scss">
	@import '~flatpickr/dist/themes/material_green.css';
.curr_datepicker{
	width:100%; 
  .has-addons{
  		margin-bottom:0;
  		width:100%;
  		position:relative;
  		input{
  			background-color:#fff;
  			border:none;
  			width:100%;
  			font-size:10px;
  		}
	    i{
	      -webkit-transition: all .3s;
	      transition: all .3s;
	      position:absolute; 
	      top:50%;
	      transform:translateY(-50%);
	       color:#aaa;
	    }
	    .fa-close{
	     display: none;
	  	 	right:0;
	      cursor: pointer;
	      pointer-events: all;
	      color:#ccc
	    }
	    .fa-calendar{
	    	right:0;
	    }
	    
	  /*  &:hover{
	      .fa-times{
	        display: inline-block;
	      }
	      .fa-calendar{
	        display: none;
	      }
	    }*/
	  }
	}
	.flatpickr-input {
	  appearance: none;
	  -webkit-appearance: none;
	  -moz-appearance: none;
	}

</style>



// WEBPACK FOOTER //
// Datepicker.vue?3257380a